jQuery(document).ready(function($){
    
    // getting the add calendar button html
    function getAddCalendarButton() {
        if( $('.tribe_events.type-tribe_events .tribe-block.tribe-block__events-link').length ) {

            let addCalendarHTML = $('.tribe_events.type-tribe_events .tribe-block.tribe-block__events-link').clone();
            let targetContainer = $('.events-detail-wrapper .meta-col .button-row .add-to-calendar-cta');

            targetContainer.html(addCalendarHTML);
            targetContainer.find('.tribe-events-c-subscribe-dropdown__button').addClass('acosta-button acosta-button--alt');
        }
    }
    getAddCalendarButton();
});